import { flow } from 'fp-ts/function';
import processExceptionValues from './processExceptionValues';
import reshapeExceptionsObject from './reshapeExceptionsObject';

const getTransformedExceptions = flow(processExceptionValues, reshapeExceptionsObject);

export default getTransformedExceptions;
